import { http } from '@/lib/http';

const toggleSSOOptions = async (payload) => {
  const response = await http.put('/saml/toggle_sso', payload);
  return response.data;
};

const syncUserManageMent = async () => {
  const response = await http.post(
    'account_integrations/rippling/users_manual_sync'
  );
  return response;
};

const getRipplingSettings = async () => {
  const response = await http.get('account_integrations/rippling/settings');
  return response.data;
};

const updateRipplingSettings = async (payload: {
  send_attachments_enabled: boolean;
}) => {
  const response = await http.patch(
    'account_integrations/rippling/settings',
    payload
  );
  return response.data;
};

const connectToHris = async (payload) => {
  const response = await http.post('/global_integrations', payload);
  return response;
};

const disconnectHris = async (payload) => {
  const response = await http.put('/global_integrations/deactivate', payload);
  return response;
};

const activateHris = async (payload) => {
  const response = await http.put('global_integrations/activate', payload);
  return response;
};

const getHrisTools = async () => {
  const response = await http.get('kombo/hris_tools');
  return response;
};

const getGlobalIntegrations = async () => {
  const response = await http.get('global_integrations');
  return response;
};

const createConnectionLink = async (payload) => {
  const response = await http.post('kombo/create_connection_link', payload);
  return response;
};

const createReConnectionLink = async (payload) => {
  const response = await http.post('kombo/create_reconnection_link', payload);
  return response;
};

const getEmployeeForm = async (payload) => {
  const response = await http.get('kombo/employee_form_prepopulated', payload);
  return response;
};

const fileToBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const base64 = (reader.result as string).split(',')[1];
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

const createEmployee = async (payload) => {
  const { employee_documents, ...restPayload } = payload;

  const processedDocuments = employee_documents
    ? await Promise.all(
        employee_documents.map(async (doc) => ({
          category_id: doc.category_id,
          files: await Promise.all(
            doc.files.map(async (f) => {
              if (f.type === 'uploaded_file' && f.file instanceof File) {
                const base64 = await fileToBase64(f.file);
                return {
                  type: 'uploaded_file',
                  file: { data: base64 },
                  filename: f.filename,
                  content_type: f.content_type,
                };
              }
              return f;
            })
          ),
        }))
      )
    : undefined;

  const response = await http.post('kombo/create_employee', {
    ...restPayload,
    ...(processedDocuments?.length
      ? { employee_documents: processedDocuments }
      : {}),
  });
  return response;
};

const getHrisFieldMappings = async (integrationType) => {
  const response = await http.get(
    `hris_field_mappings/discover_fields?integration_type=${integrationType}`
  );
  return response;
};

const getAvailableKulaFields = async () => {
  const response = await http.get('hris_field_mappings/available_kula_fields');
  return response;
};

const bulkUpdateFieldMappings = async (integrationType, payload) => {
  const response = await http.post(
    `hris_field_mappings/bulk_update?integration_type=${integrationType}`,
    payload
  );
  return response;
};

const getEmployeeDocumentCategories = async (
  integrationType,
  applicationId
) => {
  const response = await http.get(
    `kombo/employee_document_categories?integration_type=${integrationType}&ats_application_id=${applicationId}`
  );
  return response;
};

const addEmployeeDocument = async (integrationType, payload) => {
  const response = await http.post(
    `kombo/add_employee_document?integration_type=${integrationType}`,
    payload
  );
  return response;
};

export const API_SERVICE = {
  toggleSSOOptions,
  syncUserManageMent,
  getRipplingSettings,
  updateRipplingSettings,
  connectToHris,
  disconnectHris,
  getHrisTools,
  createConnectionLink,
  createReConnectionLink,
  activateHris,
  getEmployeeForm,
  createEmployee,
  getHrisFieldMappings,
  getAvailableKulaFields,
  bulkUpdateFieldMappings,
  getGlobalIntegrations,
  getEmployeeDocumentCategories,
  addEmployeeDocument,
};
